import {
    apiRequest,
} from "../../../../../services/adapters/kepegawaian/hukumanService"

class IndexRepository {

  
}

export default IndexRepository